var _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6814 6.17554C12.7702 12.3757 1.59514 14.8557 0.353516 6.17554C0.353516 -0.0245795 11.4398 -2.5932 12.6814 6.17554Z",
    fill: "#1A3864"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.06733 8.36297V6.59149C7.08505 6.35429 7.04088 6.1162 6.94331 5.90069C6.91669 5.81513 6.86336 5.73838 6.80122 5.67779C6.73037 5.6173 6.65062 5.57508 6.56196 5.55524C6.45559 5.49155 6.33129 5.4694 6.21602 5.49322C6.08293 5.56408 6.00312 5.53746 5.93208 5.70575V8.88556C5.87004 9.0627 6.0564 9.23102 6.24263 9.29303C6.42895 9.35503 6.36677 9.29298 6.42891 9.34613C6.57961 9.35091 6.73037 9.33306 6.87227 9.29303L6.93428 9.23102C7.01403 9.13244 7.05854 9.01116 7.05854 8.88556V8.30987L7.06733 8.36297Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50593 4.09193C5.48467 3.86054 5.54861 3.62948 5.69734 3.44654C5.83896 3.26359 6.04422 3.14278 6.2779 3.10914C6.50463 3.0755 6.74563 3.13165 6.92976 3.26588C7.121 3.40011 7.25541 3.60214 7.29792 3.83021C7.31918 4.0616 7.25549 4.29259 7.10676 4.47559C6.96514 4.65853 6.75964 4.7794 6.52595 4.813C6.29923 4.84667 6.06559 4.79052 5.87434 4.65626C5.6831 4.52199 5.54853 4.31999 5.50593 4.09193Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlue);
export default __webpack_public_path__ + "static/media/info-blue.62e1c85aa4bb4fe2b12ea3ff4f63935b.svg";
export { ForwardRef as ReactComponent };